<div class="card-title-block-non-sticky" *ngIf="isDocumentNotFound && !isLoading">
	<copo-back-button></copo-back-button>
	<span class="card-title-label" translate>document-card.data-not-found</span>
</div>
<div class="sidenav-content" [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" *ngIf="!(isDocumentNotFound && !isLoading)">
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="orderAckData && orderAckDisplayed">
				<div class="card-title-block-non-sticky">
					<copo-back-button></copo-back-button>
					<span class="card-title-label" translate>commercial-documents.orderAcknowledgement-card</span>
					<span class="card-title-label card-title-name-label">{{orderAckData.name ? orderAckData.name:UNDERSCORE}}</span>
					<a mat-icon-button class="order-card-document-link-block"
						[href]="getDocumentURL(orderAckData.id,orderAckData.name) | copoSafeUrl"
						target="_blank"
						type="application/pdf"
						(click)="scroller.saveState()" [title]="'quapp.action.view' | translate">
						<mat-icon color="accent" svgIcon="md:eye"></mat-icon>
					</a>
					<a mat-icon-button class="order-card-document-link-block"
						[href]="getDownloadDocumentUrl(orderAckData.id,orderAckData.name) | copoSafeUrl"
						target="_blank"
						type="application/pdf"
						(click)="scroller.saveState(); trackDownload(orderAckData.id)" [title]="'sb.Download' | translate">
						<mat-icon color="accent" svgIcon="md:download"></mat-icon>
					</a>
				</div>
				<div class="copo-container footer-margin" copoAfterViewInit
					(afterviewinit)="scroller.restoreState()">
					<div class="grid-6">
						<div class="grid-column-one-full">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title class="card-content-title">
										<span translate>commercial-documents.general-information</span>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.orderAcknowledgement-card</div>
										<div class="card-content-value">{{orderAckData.name ? orderAckData.name : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.soldto</div>
										<div class="card-content-value">{{orderAckData.soldtoName ?orderAckData.soldtoName : UNDERSCORE}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.order-reference</div>
										<div class="card-content-value">{{getOrderReference(orderAckData)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.shipto</div>
										<div class="card-content-value">{{orderAckData.shiptoName ? orderAckData.shiptoName : UNDERSCORE}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.order-acknowledgement-date</div>
										<div class="card-content-value">{{orderAckData.orderAcknowledgementDate ? (orderAckData.orderAcknowledgementDate | copoDate:'date') : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.payer</div>
										<div class="card-content-value">{{orderAckData.payerName ? orderAckData.payerName:UNDERSCORE}}</div>
									</div>
								</div>
							</div>
							</mat-expansion-panel>
						</div>
					</div>	
					<div class="grid-column-one-full document-card-batch-order-details card-title-name-label" translate>commercial-documents.orders-line-details</div>
					<div *ngFor="let orderAckDetail of orderAckData.documentLines">
						<div class="document-card-margin-bottom">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title>
										<div class="batch-details-card-first-row">
											<span class="card-sub-title" translate>commercial-documents.orders-number</span>
											<span class="card-sub-title">{{getOrderNumber(orderAckDetail) }}</span>
										</div>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
							
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.product</div>
										<div class="card-content-value">{{getProduct(orderAckDetail)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.dimensions</div>
										<div class="card-content-value">{{getDimension(orderAckDetail)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.line-status</div>
										<div class="card-content-value">{{orderAckDetail.oaLineStatusDescription ? orderAckDetail.oaLineStatusDescription :UNDERSCORE}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.product-descriptions</div>
										<div class="card-content-value">{{orderAckDetail.productDescription ? orderAckDetail.productDescription :UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>batch-card.mill</div>
										<div class="card-content-value">{{orderAckDetail.millDescription ? orderAckDetail.millDescription :UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>batch-card.mill-order-number</div>
										<div class="card-content-value">{{getMillOrderNumber(orderAckDetail)}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.final-use</div>
										<div class="card-content-value">{{(orderAckDetail.finalUse ? orderAckDetail.finalUse: UNDERSCORE)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.order-quantity</div>
										<div class="card-content-value">{{orderAckDetail.orderedQuantity ? (orderAckDetail.orderedQuantity | copoNumber:'weight':'kg') : UNDERSCORE}}</div>
									</div>
								</div>
							</div>
							</mat-expansion-panel>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>